import React, { useState } from "react";
import img from "./../../assets/images/mission-vision-values.webp";
import img1 from "./../../assets/images/mission-vision-values-2.webp";
import visionImg from "./../../assets/images/N1-vission.png";
import missionImg from "./../../assets/images/N1-mission.png";

import Button from 'react-bootstrap/Button';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import CoreValuesRadial from "./../AboutPage/ManagementTeamTab/CoreValuesRadial";



function VisionMission() {
    const [expandedIndex, setExpandedIndex] = useState(null);
    const [currentSection, setCurrentSection] = useState("section1");

    const renderTooltip = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            {/* To promote South Africa's maritime interests and development
          and position the country as an international Maritime Centre
          while ensuring maritime safety, health and environmental
          protection. */}
            The Authority championing South Africa’s maritime ambitions to be
            an International Maritime Centre by 2030

        </Tooltip>
    );

    const sectionData = {
        section1: {
            title: "Participating in the development and implementation of national",
            description:
                "Participating in the development and implementation of national and international maritime safety and marine environment protection standards.",
        },
        section2: {
            title: "Enforcing technical and operational standards for all shipping",
            description:
                "Enforcing technical and operational standards for all shipping operations in South African waters and for South African ships anywhere, to promote responsible operations in terms of seaworthiness, safety and pollution prevention.",
        },
        section3: {
            title: "Enforcing training standards and competency of Seafarers",
            description: "Enforcing training standards and competency of Seafarers.",
        },
        section4: {
            title: "Managing the national capability to respond to marine pollution",
            description:
                "Managing the national capability to respond to marine pollution incidents and other maritime emergencies.",
        },
        section5: {
            title: "Operating the Maritime Rescue Co-ordination Centre",
            description:
                "Operating the Maritime Rescue Co-ordination Centre to coordinate maritime assistance services and to detect, and co-ordinate the location and rescue of people in maritime distress situations throughout the internationally agreed South African Search and Rescue Region.",
        },
        section6: {
            title: "Overseeing the provision of maritime distress and safety",
            description:
                "Overseeing the provision of maritime distress and safety communications services to discharge South Africa's responsibilities under the Global Maritime Distress and Safety System.",
        },
        section7: {
            title: "Administering South Africa's voluntary ship reporting system",
            description:
                "Administering South Africa's voluntary ship reporting system (SAFREP) for identifying and tracking ships at sea for safety purposes and to provide a ships' database for responding to marine emergencies.",
        },
        section8: {
            title: "Investigating maritime casualties",
            description: "Investigating maritime casualties.",
        },
        section9: {
            title: "Delivering related services including",
            description: "Delivering related services including.",
        },
        section10: {
            title: "Public awareness and education in marine safety and pollution",
            description:
                "Public awareness and education in marine safety and pollution prevention.",
        },
        section11: {
            title: "Administration of South Africa's ship registration system",
            description: "Administration of South Africa's ship registration system.",
        },
        section12: {
            title:
                "Publication of, and access to, ship safety and environmental standards",
            description:
                "Publication of, and access to, ship safety and environmental standards.",
        },
    };

    const sections = Object.entries(sectionData);

    const handleToggle = (index, key) => {
        setExpandedIndex(expandedIndex === index ? null : index);
        setCurrentSection(key);
    };

    return (
        <>
            <section className="visionMission wheel-element position-relative pb-0 overflow-hidden"
                id="vision-mission">
                <h1 className="section-title text-center">VISION AND MISSION</h1>

                {/* <div className="x-scroll">
                    <ul className="visionMissionWrap d-flex">
                        <li >
                            <div className="compass-element"></div>
                        </li>
                        <li >
                            <div className="bg-primary-green p-2 h-100 d-flex flex-column justify-content-center align-items-center">
                                <i className="chess"></i>
                                <h3 className="text-center mb-2">MISSION</h3>
                                <p className="text-center text-white font-18">
                                    The Authority championing South Africa’s maritime ambitions to be
                                    an International Maritime Centre by 2030
                                    <OverlayTrigger
                                        placement="top"
                                        delay={{ show: 250, hide: 400 }}
                                        overlay={renderTooltip}
                                    >
                                        <Button variant="success">...</Button>
                                    </OverlayTrigger>
                                </p>
                            </div>
                        </li>
                        <li >
                            <div className="bg-green-0d964e p-2 h-100 d-flex flex-column justify-content-center align-items-center">
                                <i className="glass-icon"></i>
                                <h3 className="text-center mb-2">VISION</h3>
                                <p className="text-center text-white font-18">
                                    To provide leadership in maritime safety, prevent and combat marine pollution for a sustainable maritime environment whilst supporting an innovative, progressive and a vibrant maritime economy.
                                </p>
                            </div>
                        </li>
                        <li >
                            <div className="spects-element"></div>
                        </li>
                    </ul>
                </div> */}

                <div className="x-scroll">
                    <ul className="visionMissionWrap d-flex" >
                        <li>
                            <div className="compass-element"></div>
                        </li>
                        <li>
                            <div className="bg-green-0d964e p-5 h-100 d-flex flex-column justify-content-cener align-items-center">
                                <i className="glass-icon"></i>
                                <h3 className="text-center mb-2">VISION  </h3>
                                <p className="text-center text-white font-18">“A model maritime safety authority promoting South Africa`s maritime interests.”</p>
                            </div>
                            
                        </li>
                        <li>
                            <div className="bg-primary-green p-5 h-100 d-flex flex-column justify-content-cener align-items-center">
                                <i className="chess"></i>
                                <h3 className="text-center mb-2">mission </h3>
                                <p className="text-center text-white font-18">“To provide leadership in maritime safety, prevention and combating marine pollution for a sustainable maritime environment, whilst supporting an innovative, progressive and vibrant maritime economy”.</p>
                            </div>
                        </li>
                        <li><div className="spects-element"></div></li>
                    </ul>
                </div>

                <section className='p-0' id="Core-Values">
                    <CoreValuesRadial />
                </section>

                <div className="services py-5">
                    <div className="container max-1330">
                        <div className="row g-5">
                            <div className="col-lg-12 col-md-12">
                                <p className="font-18 mb-3 text-primary-color font-800">
                                    <span className="d-block text-primary-green" style={{ fontSize: '24px', fontWeight: 800 }}>In line with its objectives, as stated in Section 3 of the
                                        SAMSA Act, the SAMSA’s primary areas of responsibility
                                        include:</span>

                                </p>

                                <div className="accordion blackTab" id="blackTab">
                                    <div className="accordion-item">
                                        <h2 className="accordion-header">
                                            <button className="accordion-button collapsed"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#blackTabOne"
                                                aria-expanded="false"
                                                aria-controls="blackTabOne">
                                                Participating in the development and implementation
                                            </button>
                                        </h2>
                                        <div id="blackTabOne"
                                            className="accordion-collapse collapse"
                                            data-bs-parent="#blackTab">
                                            <div className="accordion-body">
                                                <p className="mb-3">Participating in the development and implementation of national and international maritime safety and marine environment protection standards;</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="accordion-item">
                                        <h2 className="accordion-header">
                                            <button className="accordion-button "
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#blackTabTwo"
                                                aria-expanded="true"
                                                aria-controls="blackTabTwo">
                                                Enforcing technical and operational standards for all shipping
                                            </button>
                                        </h2>
                                        <div id="blackTabTwo"
                                            className="accordion-collapse collapse show"
                                            data-bs-parent="#blackTab">
                                            <div className="accordion-body">
                                                <p className="mb-3">Enforcing technical and operational standards for all shipping operations in South African waters and for South African ships anywhere, to promote responsible operations in terms of seaworthiness, safety and pollution prevention;</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="accordion-item">
                                        <h2 className="accordion-header">
                                            <button className="accordion-button collapsed"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#blackTabThree"
                                                aria-expanded="false"
                                                aria-controls="blackTabThree">
                                                Enforcing training standards and competency of Seafarers
                                            </button>
                                        </h2>
                                        <div id="blackTabThree"
                                            className="accordion-collapse collapse"
                                            data-bs-parent="#blackTab">
                                            <div className="accordion-body">
                                                <p className="mb-3">Enforcing training standards and competency of Seafarers;</p>
                                            </div>
                                        </div>

                                    </div>

                                    <div className="accordion-item">
                                        <h2 className="accordion-header">
                                            <button className="accordion-button collapsed"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#blackTabFour"
                                                aria-expanded="false"
                                                aria-controls="blackTabFour">Managing the national capability to respond to marine
                                            </button>
                                        </h2>
                                        <div id="blackTabFour"
                                            className="accordion-collapse collapse"
                                            data-bs-parent="#blackTab">
                                            <div className="accordion-body">
                                                <p className="mb-3">Managing the national capability to respond to marine pollution incidents and other maritime emergencies;</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="accordion-item">
                                        <h2 className="accordion-header">
                                            <button className="accordion-button collapsed"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#blackTab5"
                                                aria-expanded="false"
                                                aria-controls="blackTab5">
                                                Operating the Maritime Rescue Co-ordination Centre to
                                            </button>
                                        </h2>
                                        <div id="blackTab5"
                                            className="accordion-collapse collapse"
                                            data-bs-parent="#blackTab">
                                            <div className="accordion-body">
                                                <p className="mb-3">Operating the Maritime Rescue Co-ordination Centre to coordinate maritime assistance services and to detect, and co-ordinate the location and rescue of people in maritime distress situations throughout the internationally agreed South African Search and Rescue Region;</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="accordion-item">
                                        <h2 className="accordion-header">
                                            <button className="accordion-button collapsed"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#blackTab6"
                                                aria-expanded="false"
                                                aria-controls="blackTab6">
                                                Overseeing the provision of maritime distress and safety
                                            </button>
                                        </h2>
                                        <div id="blackTab6"
                                            className="accordion-collapse collapse"
                                            data-bs-parent="#blackTab">
                                            <div className="accordion-body">
                                                <p className="mb-3">Overseeing the provision of maritime distress and safety communications services to discharge South Africa's responsibilities under the Global Maritime Distress and Safety System;</p>

                                            </div>
                                        </div>
                                    </div>

                                    <div className="accordion-item">
                                        <h2 className="accordion-header">
                                            <button className="accordion-button collapsed"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#blackTab7"
                                                aria-expanded="false"
                                                aria-controls="blackTab7">Administering South Africa's voluntary ship reporting system (SAFREP)
                                            </button>
                                        </h2>
                                        <div id="blackTab7"
                                            className="accordion-collapse collapse"
                                            data-bs-parent="#blackTab">
                                            <div className="accordion-body">
                                                <p className="mb-3">Administering South Africa's voluntary ship reporting system (SAFREP) for identifying and tracking ships at sea for safety purposes and to provide a ships' database for responding to marine emergencies;</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="accordion-item">
                                        <h2 className="accordion-header">
                                            <button className="accordion-button collapsed"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#blackTab8"
                                                aria-expanded="false"
                                                aria-controls="blackTab8">Investigating maritime casualties
                                            </button>
                                        </h2>
                                        <div id="blackTab8"
                                            className="accordion-collapse collapse"
                                            data-bs-parent="#blackTab">
                                            <div className="accordion-body">
                                                <p className="mb-3">Investigating maritime casualties; and</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="accordion-item">
                                        <h2 className="accordion-header">
                                            <button className="accordion-button collapsed"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#blackTab9"
                                                aria-expanded="false"
                                                aria-controls="blackTab9">Delivering related services including
                                            </button>
                                        </h2>
                                        <div id="blackTab9"
                                            className="accordion-collapse collapse"
                                            data-bs-parent="#blackTab">
                                            <div className="accordion-body">
                                                <p className="mb-3">Delivering related services including</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="accordion-item">
                                        <h2 className="accordion-header">
                                            <button className="accordion-button collapsed"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#blackTab10"
                                                aria-expanded="false"
                                                aria-controls="blackTab10">Public awareness and education in marine
                                            </button>
                                        </h2>
                                        <div id="blackTab10"
                                            className="accordion-collapse collapse"
                                            data-bs-parent="#blackTab">
                                            <div className="accordion-body">
                                                <p className="mb-3">Public awareness and education in marine safety and pollution prevention;</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="accordion-item">
                                        <h2 className="accordion-header">
                                            <button className="accordion-button collapsed"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#blackTab11"
                                                aria-expanded="false"
                                                aria-controls="blackTab11">Administration of South Africa's ship
                                            </button>
                                        </h2>
                                        <div id="blackTab11"
                                            className="accordion-collapse collapse"
                                            data-bs-parent="#blackTab">
                                            <div className="accordion-body">
                                                <p className="mb-3">Administration of South Africa's ship registration system; and</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="accordion-item">
                                        <h2 className="accordion-header">
                                            <button className="accordion-button collapsed"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#blackTab12"
                                                aria-expanded="false"
                                                aria-controls="blackTab12">Publication of, and access to, ship
                                            </button>
                                        </h2>
                                        <div id="blackTab12"
                                            className="accordion-collapse collapse"
                                            data-bs-parent="#blackTab">
                                            <div className="accordion-body">
                                                <p className="mb-3">Publication of, and access to, ship safety and environmental standards.</p>

                                            </div>
                                        </div>
                                    </div>
                                    <p className="font-18 mb-3 text-primary-color font-800">
                                        <span className="d-block text-primary-green" style={{ fontSize: '24px', fontWeight: 800 }}>
                                            SAMSA delivers four main outputs consistent with its mandate and responsibilities:</span>

                                    </p>

                                    <div className="accordion-item">
                                        <h2 className="accordion-header">
                                            <button className="accordion-button collapsed"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#blackTab13"
                                                aria-expanded="false"
                                                aria-controls="blackTab13">Safety and environment protection standards
                                            </button>
                                        </h2>
                                        <div id="blackTab13"
                                            className="accordion-collapse collapse"
                                            data-bs-parent="#blackTab">
                                            <div className="accordion-body">
                                                <p className="mb-3">Safety and environment protection standards for responsible maritime transport operations;</p>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="accordion-item">
                                        <h2 className="accordion-header">
                                            <button className="accordion-button collapsed"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#blackTab14"
                                                aria-expanded="false"
                                                aria-controls="blackTab14">An infrastructure for monitoring and enforcing
                                            </button>
                                        </h2>
                                        <div id="blackTab14"
                                            className="accordion-collapse collapse"
                                            data-bs-parent="#blackTab">
                                            <div className="accordion-body">
                                                <p className="mb-3">An infrastructure for monitoring and enforcing compliance with safety and environment protection standards;</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="accordion-item">
                                        <h2 className="accordion-header">
                                            <button className="accordion-button collapsed"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#blackTab15"
                                                aria-expanded="false"
                                                aria-controls="blackTab15">The capability to respond to marine
                                            </button>
                                        </h2>
                                        <div id="blackTab15"
                                            className="accordion-collapse collapse"
                                            data-bs-parent="#blackTab">
                                            <div className="accordion-body">
                                                <p className="mb-3">The capability to respond to marine pollution incidents and other maritime emergencies; and</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="accordion-item">
                                        <h2 className="accordion-header">
                                            <button className="accordion-button collapsed"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#blackTab16"
                                                aria-expanded="false"
                                                aria-controls="blackTab16">The capability to detect, locate
                                            </button>
                                        </h2>
                                        <div id="blackTab16"
                                            className="accordion-collapse collapse"
                                            data-bs-parent="#blackTab">
                                            <div className="accordion-body">
                                                <p className="mb-3">
                                                    The capability to detect, locate and rescue people in maritime distress situations.</p>
                                            </div>
                                        </div>
                                    </div>







                                </div>





                            </div>

                            {/* Image column completely hidden by not rendering it */}
                            {/* If you want to bring it back later, just uncomment this part:
                <div className="col-lg-6 col-md-5 d-none">
                    <img src={imgIndex % 2= = =0 ? img1 : img}
                         className="img-fluid"
                         alt={currentSection} />
                </div>
                */}
                        </div>
                    </div>
                </div>




            </section>
        </>
    );
}

export default VisionMission;
